import Component from "@lib/Component.js";
import Cookies from "js-cookie";
import gsap from "gsap";
import { addEvent, removeEvent, addClass, removeClass } from "@qneyraud/q-utils";

const COOKIE_KEY = "site_choice";
const COOKIE_EXPIRE = 365;

export default class SiteChoiceModal extends Component {
  init() {
    super.init();
    this.bindMethods();
  }

  bindMethods() {
    this.stayOnSite = this.stayOnSite.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    if (this.isDisplayed()) {
      this.show();
    }
  }

  show() {
    addClass(document.body, "no-scroll");
    gsap.to(this.el, {
      duration: 0.5,
      autoAlpha: 1,
      onComplete: (_) => {
        addEvent(this.refs["button-pro"], "click", this.stayOnSite);
        addEvent(document.body, "click", this.onDocumentClick);
        addEvent(this.refs.close, "click", this.stayOnSite);
      }
    });
  }

  hide() {
    gsap.to(this.el, {
      duration: 0.5,
      autoAlpha: 0,
      onComplete: (_) => {
        addClass(this.el, "hidden");
        removeEvent(this.refs["button-pro"], "click", this.stayOnSite);
        removeEvent(document.body, "click", this.onDocumentClick);
        removeClass(document.body, "no-scroll");
      }
    });
  }

  isDisplayed() {
    return !Cookies.get(COOKIE_KEY);
  }

  stayOnSite() {
    this.hide();
    Cookies.set(COOKIE_KEY, "ok", {
      expires: COOKIE_EXPIRE
    });
  }

  onDocumentClick(e) {
    if (!this.refs.modal.contains(e.target)) {
      this.stayOnSite();
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/SiteChoiceModal.js